import React, { Component } from "react";
import Structure from "../../components/structure/Structure";
import FinishedDialog from "../../components/FinishedDialog";

class StructureContainer extends Component {
  state = {
    numDivided: 0,
    teamsPerDivision: {},
    teamsLoaded: false,
    finishedDialogOpen: false,
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams")
      .onSnapshot((querySnapshot) => {
        let teamsPerDivision = {};
        let numDivided = 0;
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          if (
            team.poule0 ||
            team.poule1 ||
            team.poule2 ||
            team.poule3 ||
            team.poule4 ||
            team.poule5
          ) {
            numDivided++;
          }
          if (teamsPerDivision[team.division] === undefined) {
            teamsPerDivision[team.division] = [];
          }
          teamsPerDivision[team.division].push(team);
        });
        this.setState({
          numDivided: numDivided,
          teamsPerDivision: teamsPerDivision,
          teamsLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  render() {
    let maxTeams = 8;
    if (
      this.props.tournamentStatus.status === 2 ||
      this.props.userStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 3
    ) {
      maxTeams = 2400;
    } else if (
      this.props.tournamentStatus.status === 1 ||
      this.props.userStatus.status === 1
    ) {
      maxTeams = 60;
    }
    return (
      <div>
        {(this.props.tournamentAdmin === undefined ||
          this.props.tournamentAdmin.manageFormat) && (
          <Structure
            tournament={this.props.tournament}
            divisions={this.props.divisions}
            divisionsObject={this.props.divisionsObject}
            numDivided={this.state.numDivided}
            teamsPerDivision={this.state.teamsPerDivision}
            teamsLoaded={this.state.teamsLoaded}
            maxTeams={maxTeams}
            user={this.props.user}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.toggleFinishedDialog}
            userData={this.props.userData}
          />
        )}
        <FinishedDialog
          open={this.state.finishedDialogOpen}
          handleClose={this.toggleFinishedDialog}
        />
      </div>
    );
  }
}

export default StructureContainer;
